import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-boligkvalitet",
  templateUrl: "./boligkvalitet.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class BoligkvalitetComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Tilsagn";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForSoknad: string[] = [];
  grafIderForBolig: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForKostnad: string[] = [];
  kpiListe: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      boliger: ["Antall boliger", "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      kostnad: [
        "Gjennomsnittlig prosjektkostnad per bolig",
        "Viser gjennomsnittlig prosjektkostnad per bolig for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall boliger» i valgt periode og saksbehandlingsstatus.",
      ],
    },
    Tilsagn: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      boliger: ["Antall boliger", "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      kostnad: [
        "Gjennomsnittlig prosjektkostnad per bolig",
        "Viser gjennomsnittlig prosjektkostnad per bolig for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall boliger» i valgt periode og saksbehandlingsstatus.",
      ],
    },
    Utbetaling: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      boliger: ["Antall boliger", "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. "],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      kostnad: [
        "Gjennomsnittlig prosjektkostnad per bolig",
        "Viser gjennomsnittlig prosjektkostnad per bolig for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall boliger» i valgt periode og saksbehandlingsstatus.",
      ],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("TypeTilstand", "Tilsagn", false, true);
    this.qlikService.setFilter("VirkemiddelKode", "LÅN_HB", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Lån til boligkvalitet - Husbanken");
    this.grafIderForSoknad = ["hvb-ant-saker-pr-fylke", "hvb-ant-saker", "hvb-ant-saker-pr-tiltak", "hvb-ant-saker-pr-delformål"];
    this.grafIderForBolig = ["hvb-ant-boliger-pr-fylke", "hvb-ant-boliger", "hvb-ant-boliger-pr-tiltak", "hvb-ant-boliger-pr-delformål"];
    this.grafIderForBelop = ["hvb-belop-pr-fylke", "hvb-belop", "hvb-belop-pr-tiltak"];
    this.grafIderForKostnad = ["hvb-kostnad-pr-fylke", "hvb-kostnad", "hvb-kostnad-pr-tiltak"];

    this.kpiListe = ["HVB Antall saker", "HVB Antall boliger", "HVB Beløp", "HVB Gjennomsnittlig kostnad pr bolig"];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.qlikService.setFilter("VirkemiddelKode", "LÅN_HB", false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    return this.typeTekst[this.statistikkType][this.graferValgt][0];
  }
}
